import { render, staticRenderFns } from "./administratorManage.vue?vue&type=template&id=c118e460&scoped=true&"
import script from "./administratorManage.vue?vue&type=script&lang=js&"
export * from "./administratorManage.vue?vue&type=script&lang=js&"
import style0 from "./administratorManage.vue?vue&type=style&index=0&id=c118e460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c118e460",
  null
  
)

export default component.exports